import React from 'react';
import PropTypes from 'prop-types';

const HtmlEditor = ({ onChange, value, name, cols, rows }) => {
  const handleTextAreaChange = e => {
    onChange(name, e.target.value);
  };

  return (
    <textarea
      name={name}
      value={value}
      onChange={handleTextAreaChange}
      style={{ resize: 'both' }}
      cols={cols}
      rows={rows}
    />
  );
};

HtmlEditor.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  cols: PropTypes.string,
  rows: PropTypes.string,
};

HtmlEditor.defaultProps = {
  value: '',
  cols: '57',
  rows: '10',
};

export default HtmlEditor;
